import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	placeholderNoneEntered: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	placeholderNoneSelected: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	placeholderNoneEntered: {
		id: 'servicedesk-insight-attribute-views.common.placeholder-none-entered',
		defaultMessage: 'None entered',
		description: 'Place holder text for an CMDB attribute when it does not have a value set.',
	},
	placeholderNoneSelected: {
		id: 'servicedesk-insight-attribute-views.common.placeholder-none-selected',
		defaultMessage: 'None selected',
		description: 'Place holder text for an CMDB attribute when it does not have a value selected.',
	},
});
export default messages;
